import React from 'react'

import Widget from '@/components/widget/Widget'

import { QAActivityTable } from './QAActivityTable'

export const TableSection = () => {
  return (
    <Widget label="QA Activity Events" showCsvDownload>
      <QAActivityTable />
    </Widget>
  )
}
